import React from 'react';

import {
  errorUtil,
  fields
} from 'iron-forge-react-modules';
import {
  BaseTier1ReturnAuthorizationModal,
  selectFields
} from 'modules/layer01';

import { appValidationUtil } from 'modules/layer00';
import { useForm } from 'react-hook-form';
import { Stack } from '@mui/material';
import * as dataService from './dataService';
import * as types from './types';



const ControlledTextField = fields.TextField.genControllerComponent<types.IFormState>();



export interface IProps {
  returnAuthorizationId: string;
  storeId: string;

  onClose: () => void;
  onFinish: () => void;
}

export const FC: React.FC<IProps> = props => {
  const { genController } = selectFields.RepairCodeSelectField.genComponentAndControllerGenerator(props.storeId);
  const ControlledRepairCodeSelectField = genController<types.IFormState>();

  const queryTuple = dataService.useQuery(props.returnAuthorizationId);
  const [
    triageReturnAuthorization,
    triageReturnAuthorizationTuple
  ] = dataService.useTriageTier1ReturnAuthorization(props.returnAuthorizationId, queryTuple.data.triageWorkflowId);
  const form = useForm<types.IFormState>({
    defaultValues: {
      repairCode: null,
      replacementSerialNumber: '',
      technicianComment: ''
    }
  });

  const processSubmit = React.useCallback(
    (formState: types.IFormState) => {
      props.onFinish();
      errorUtil.errorWrap(async () => {
        await triageReturnAuthorization(formState);
      });
    },
    [
      props,
      triageReturnAuthorization
    ]
  );

  const loading = queryTuple.loading || triageReturnAuthorizationTuple.loading;
  return (
    <BaseTier1ReturnAuthorizationModal.FC
      title="Replace Item"
      primaryText="Review and confirm to replace the customer item"
      secondaryText="Add item to be restocked"
      disableButtons={loading}
      onClose={props.onClose}
      onSubmit={form.handleSubmit(processSubmit)}>
      <Stack>
        <ControlledRepairCodeSelectField
          label="Repair Code"
          fieldKey="repairCode"
          isRequired
          formControl={form.control} />

        <ControlledTextField
          label="Replacement IMEI"
          placeholder="Scan or Select Restock SKU"
          fieldKey="replacementSerialNumber"
          formControl={form.control}
          isRequired
          extraValidationRules={{ pattern: appValidationUtil.reImei }} />

        <ControlledTextField
          label="Technician Comment"
          fieldKey="technicianComment"
          formControl={form.control}
          numLines={5} />
      </Stack>
    </BaseTier1ReturnAuthorizationModal.FC>
  );
};
